import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { CashbookTxnLineService, CashbookService } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../visa';
import { SubSink } from 'subsink2';
import { ListingService } from '../../../services/listing-service';
import { ListingInputModel } from '../../../models/listing-input.model';
import { SharedUtilitiesHelperFunctions } from '../../helper-functions';

@Component({
  selector: 'app-cash-document-posting-cashbook-txn',
  templateUrl: './cashbook-txn.component.html',
  styleUrls: ['./cashbook-txn.component.css']
})
export class CashDocumentPostingCashbookTxnComponent implements OnInit, OnDestroy {
  @Input() cashDoc;
  protected subs = new SubSink();

  cashbookMap: {guid: string, acc_no: string}[] = [];

  gridApi;
  gridColumnApi;
  rowData: [];
  gridOptions = {
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalAndFilteredRowCountComponent', key: 'totalAndFilter', align: 'left' },
      ]
    },
    defaultColDef: {
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 100,
      flex: 1,
      sortable: true,
      resizable: true,
      suppressCsvExport: true,
      floatingFilter: true
    },
    pagination: true
  }

  columnsDefs = [
    {
      headerName: 'Txn Date', field: 'date_txn_doc', cellStyle: () => ({ 'text-align': 'left' }),
      valueFormatter: params => params.value ? SharedUtilitiesHelperFunctions.dateFormatter(params.value, 'YYYY-MM-DD') : '',
    },
    { headerName: 'Accout No', field: 'bl_fi_mst_cashbook_hdr.acc_no', cellStyle: () => ({ 'text-align': 'left' }) },
    { headerName: 'Remarks', field: 'descr', cellStyle: () => ({ 'text-align': 'left' }) },
    {
      headerName: 'Amount', field: 'txn_amount', type: 'numericColumn',
      valueFormatter: params => params.value? SharedUtilitiesHelperFunctions.currencyFormatter(params.value):'',
    },
  ];

  constructor(
    protected listingService: ListingService,
    protected cashbookTxnLineService :CashbookTxnLineService,
    protected cashbookService :CashbookService
  ) {}

  ngOnInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
    if(this.cashDoc){
      this.createData()
    }
  }

  createData() {
    const formData = this.getInputModel();

    this.subs.sink = this.listingService.get("cashbook-txn-line/backoffice-ep", formData, AppConfig.apiVisa)
    .subscribe(resp => {
      this.gridApi.setRowData(resp.data);
    }, err => {
      console.log(err);
    });
  }

  getInputModel() {
    const inputModel = {} as ListingInputModel;
    inputModel.status = ['ACTIVE'];
    inputModel.orderBy = 'updated_date';
    inputModel.order = 'desc';
    inputModel.limit = null;
    inputModel.offset = 0;
    inputModel.calcTotalRecords = true;
    inputModel.showCreatedBy = true;
    inputModel.showUpdatedBy = true;
    inputModel.filterLogical= 'AND';
    inputModel.filterConditions = [];
    inputModel.joins = [
      {
        tableName: "bl_fi_mst_cashbook_hdr",
        joinColumn: "guid_cashbook",
        columns: ["code", "name"],
        joinType: "left join"
      },
    ]

    if (this.cashDoc) {
      inputModel.filterConditions.push({
        filterColumn: 'cash_document_hdr_guid',
        filterValues: [this.cashDoc?.bl_fi_cash_document_hdr?.guid?.toString()],
        filterOperator : 'IN'
      });
    }

    return inputModel;
  }


  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
